<mat-icon class="material-icons-outlined" [fontIcon]="icon"></mat-icon>